module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-transfer', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    ref: "selected_user",
    class: ['omnis-transfer', {
      'header-is-disabled': _vm.header_check_disabled
    }],
    attrs: {
      "titles": ['未选用户', '已选用户'],
      "filterable": "",
      "filter-method": _vm.filterMethod,
      "filter-placeholder": "请输入用户名、拼音、账号",
      "data": _vm.data_all
    },
    model: {
      value: (_vm.data_selected),
      callback: function($$v) {
        _vm.data_selected = $$v
      },
      expression: "data_selected"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-017895c5","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/omnis-business/user-transfer/user-transfer.vue
// module id = 5BnT
// module chunks = 81